import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {ID} from 'simpli-web-sdk'

@Component
export class MixinMember extends Vue {
  @Prop({required: true}) value!: any

  memberEvent(id: ID) {
    this.value.idFilial = id
  }
}
